import type { CardDef } from '../types/cards';
import type { Effect } from '../types/effects';
import type { Color } from '../types/resources';
import { cost } from './helpers';

const perNeighborCard = (colors: Color[], amount: number): Effect => ({
  kind: 'vpPer',
  count: { kind: 'cards', colors },
  scopes: ['left', 'right'],
  amount,
});

type GuildDef = Omit<CardDef, 'copies' | 'guild'>;

/** Gremios (Era III): 10 en la caja, se usan N+2 al azar. */
const GUILDS: GuildDef[] = [
  { id: 'workers_guild', color: 'purple', cost: cost('OOWSC'), effects: [perNeighborCard(['brown'], 1)] },
  // Coste a verificar contra la copia física (fuentes públicas discrepan: SSOO vs SSO).
  { id: 'craftsmens_guild', color: 'purple', cost: cost('SSOO'), effects: [perNeighborCard(['grey'], 2)] },
  { id: 'magistrates_guild', color: 'purple', cost: cost('WWWSL'), effects: [perNeighborCard(['blue'], 1)] },
  { id: 'traders_guild', color: 'purple', cost: cost('GPL'), effects: [perNeighborCard(['yellow'], 1)] },
  { id: 'spies_guild', color: 'purple', cost: cost('CCG'), effects: [perNeighborCard(['red'], 1)] },
  { id: 'philosophers_guild', color: 'purple', cost: cost('CCCPL'), effects: [perNeighborCard(['green'], 1)] },
  {
    id: 'shipowners_guild',
    color: 'purple',
    cost: cost('WWWGP'),
    effects: [{ kind: 'vpPer', count: { kind: 'cards', colors: ['brown', 'grey', 'purple'] }, scopes: ['self'], amount: 1 }],
  },
  { id: 'scientists_guild', color: 'purple', cost: cost('WWOOP'), effects: [{ kind: 'scienceWild' }] },
  {
    id: 'builders_guild',
    color: 'purple',
    cost: cost('SSSCCG'),
    effects: [{ kind: 'vpPer', count: { kind: 'wonderStages' }, scopes: ['self', 'left', 'right'], amount: 1 }],
  },
  { id: 'decorators_guild', color: 'purple', cost: cost('OOSL'), effects: [{ kind: 'vpIfWonderComplete', amount: 7 }] },
];

export const GUILD_CARDS: CardDef[] = GUILDS.map((g) => ({ ...g, guild: true, copies: [{ age: 3, minPlayers: 3 }] }));
